import _ from "lodash";
import {
  isPortfolioFilterRevamp,
  isPortfolioParityEnabled,
  getIsSchedulePostTabEnabled,
} from "AppComponents/Post/utils";
import moment from "moment";

export const getSortedStudentList = ({ unsortedStudentList }) => {
  return _.sortBy(unsortedStudentList, [
    "node.isArchived",
    student => {
      _.lowerCase(student?.node?.firstName);
    },
  ]);
};

// Scheduled posts are only meant for staff users
export const getPostFeedFilters = ({ userType = "", filters = {}, userId }) => {
  const postFeedFilters = { ...filters };
  if (getIsSchedulePostTabEnabled()) {
    if (userType === "staff") {
      if (_.get(filters, "state") === "SCHEDULED") {
        postFeedFilters.state = "SCHEDULED";
      } else if (_.get(filters, "state") === "PUBLISHED") {
        postFeedFilters.state = "PUBLISHED";
      }
    }
  } else {
    if (userType === "staff" && _.get(filters, "state") === "PUBLISHED") {
      postFeedFilters.states = ["PUBLISHED", "SCHEDULED"];
      postFeedFilters.state = undefined;
    }
  }

  if (
    userType == "student" &&
    _.get(filters, "state") == "PUBLISHED" &&
    isPortfolioParityEnabled()
  ) {
    postFeedFilters.states = ["PUBLISHED", "IN_APPROVAL"];
    postFeedFilters.state = undefined;
  }

  if (
    userType == "student" &&
    _.get(filters, "state") == "DRAFT" &&
    isPortfolioParityEnabled()
  ) {
    postFeedFilters.studentIds = userId;
  }

  if (!_.isNil(postFeedFilters.duration) && isPortfolioFilterRevamp()) {
    postFeedFilters.duration = !_.isNil(postFeedFilters.duration)
      ? {
          fromDate:
            !_.isNull(postFeedFilters?.duration?.fromDate) &&
            moment.isMoment(postFeedFilters?.duration?.fromDate)
              ? moment(
                  postFeedFilters?.duration?.fromDate.format("YYYY-MM-DD")
                ).toISOString()
              : postFeedFilters?.duration?.fromDate ?? null,
          toDate:
            !_.isNull(postFeedFilters?.duration?.toDate) &&
            moment.isMoment(postFeedFilters?.duration?.toDate)
              ? moment(postFeedFilters?.duration?.toDate.format("YYYY-MM-DD"))
                  .add({ hours: 23, minutes: 59 })
                  .toISOString()
              : postFeedFilters?.duration?.toDate ?? null,
        }
      : undefined;
  }
  postFeedFilters.feedTypes = ["PORTFOLIO"];

  return postFeedFilters;
};

export const getSortedStudentListMemoize = _.memoize(
  getSortedStudentList,
  ({ unsortedStudentList }) => {
    return _.map(unsortedStudentList, student => {
      // Collect all keys except 'node'
      const keys = _.keys(student).filter(key => key !== "node");
      // Build a string of key-value pairs for memoization
      const keyValueString = keys
        .map(key => `${key}:${student[key]}`)
        .join(",");
      // Always include node.id and node.isArchived for uniqueness
      return `${student?.node?.id}_${student?.node?.isArchived}_${keyValueString}`;
    }).join("|");
  }
);

export const getPostFeedFiltersMemoized = _.memoize(
  getPostFeedFilters,
  ({ userType, filters, userId }) => {
    const sortedKeys = _.sortBy(_.keys(filters || []));
    const sortedFilters = _.pick(filters, sortedKeys);
    return `${userType || ""}_${userId || ""}_${JSON.stringify(sortedFilters)}`;
  }
);

export const getTagsMemoized = _.memoize(
  ({ tagsFromProps }) => {
    const tagsOptions = [
      {
        label: "Untagged",
        value: "unTaggedWithFolder",
      },
    ];
    _.forEach(tagsFromProps, tag => {
      tagsOptions.push({
        label: _.get(tag, "name", ""),
        value: _.get(tag, "id"),
      });
    });
    return tagsOptions;
  },
  ({ tagsFromProps }) => {
    return _.map(tagsFromProps, "id").join("|");
  }
);
